module.exports = __webpack_public_path__ + "static/media/rose-gold-ring.ec5f999f.png";